import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Contact_us from "./components/contact_us/Contact_us";
import Privacy_policy from "./components/privacy-policy/Privacy_policy";
import Terms_conditions from "./components/terms-conditions/Terms_conditions";
import About_Us from "./components/about_us/About_Us";
import Blog from "./components/blog/Blog";
import Gallery from "./components/gallery/Gallery";
import Details_blog from "./components/blog/detail_blog/Details_blog";
import Sports_program from "./components/sports_program/Sports_program";


function App() {
  return (
    <>
      {/* <ScrollToTop /> */}
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} /> 
        <Route path="/sports-programs" element={<Sports_program />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blogs/:id" element={<Details_blog />} />
        <Route path="/contact-us" element={<Contact_us />} />

        <Route path="/terms-conditions" element={<Terms_conditions />} />
        <Route path="/privacy-policy" element={<Privacy_policy />} />

      </Routes>
      <Footer />
    </>
  );
}

export default App;
